export default (availableFieldList) => {
    const fields = [];
    const getFields = (availableFieldList) => {
        for (const field of availableFieldList) {
            fields.push(field);
            if (field.AvailableFieldList && field.Type !== "list") {
                getFields(field.AvailableFieldList);
            }
            if (field.Options) {
                for (const option of field.Options) {
                    if (option.AvailableFieldList) {
                        getFields(option.AvailableFieldList);
                    }
                }
            }
        }
    };

    getFields(availableFieldList);

    return fields;
}